import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import GS from '../../grafsync/grafsync';
import PrimaryButton from '../PrimaryButton';
import { globalStyles as styles } from '../style/gstheme';
import TitledPanel from '../TitledPanel';
import { MAX_FAMILYNAME_LENGTH, MAX_GIVENNAME_LENGTH } from '../utils/constants';
import NameField from '../mydetails/NameField';

class MyDetails extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            givenName: "",
            familyName: "",
            isDirty: false
        };
    }

    onUpdate = (property) => (value) => {
        this.setState({ [property]: value, isDirty: true });
    }

    saveUpdates = () => {
        const { givenName, familyName } = this.state;
        GS.updateUser(this.props.user.id, {
            ...(givenName && givenName !== "") && { givenName },
            ...(familyName && familyName !== "") && { familyName }
        })
        this.props.updateUser({
            ...(givenName && givenName !== "") && { givenName },
            ...(familyName && familyName !== "") && { familyName }
        })
        this.setState({ isDirty: false });
        this.props.done();
    }

    render() {

        const { givenName, familyName, isDirty } = this.state;

        return (
            <form autoComplete="off">
                <Grid container spacing={2} classes={
                    {
                        "spacing-xs-2": this.props.classes.fullGrid
                    }
                }>
                    <Grid item xs={12}>
                        <TitledPanel title="Given Name" height="full">
                            <NameField
                                fullWidth
                                autoComplete="given-name"
                                isMandatory={false}
                                maxLength={MAX_GIVENNAME_LENGTH}
                                text={givenName || ""}
                                onUpdate={this.onUpdate("givenName")} />
                        </TitledPanel>
                    </Grid>
                    <Grid item xs={12}>
                        <TitledPanel title="Family Name" height="full">
                            <NameField
                                fullWidth
                                autoComplete="family-name"
                                isMandatory={false}
                                maxLength={MAX_FAMILYNAME_LENGTH}
                                text={familyName || ""}
                                onUpdate={this.onUpdate("familyName")} />
                        </TitledPanel>
                    </Grid>
                    <Grid item xs={12}>
                        <div style={{ float: 'right' }}>
                            <PrimaryButton disabled={!isDirty} onClick={this.saveUpdates}>Save</PrimaryButton>
                        </div>
                    </Grid>
                </Grid>
            </form>
        );
    }
}

MyDetails.propTypes = {
    classes: PropTypes.object,
    user: PropTypes.object.isRequired,
    updateUser: PropTypes.func.isRequired
}

export default withStyles(styles)(MyDetails);